import Breakpoints from '../utils/Breakpoints';

const config = {
  mobile: {
    header: [
      '.branding',
      '.toolbar',
    ],
    flyout: [
      '.site-search.block',
      '.secondary-links',
      '.gtranslate',
      '.primary-navigation',
    ],
  },
  desktop: {
    header: [
      '.branding',
      '.toolbar',
      '.site-search.block',
      '.gtranslate',
      '.secondary-links',
      '.primary-navigation',
    ],
    flyout: [],
  },
};

export default class Shift {
  constructor(element) {
    this.element = element;
    this.config = config;

    if (!this.header || !this.flyout) {
      throw Error('Header module requires a .header .layout and .flyout .layout element to proceed.');
    }

    this.listen();
    this.ready();
  }

  update() {
    const state = Breakpoints.mobileState ? 'mobile' : 'desktop';
    Object.entries(this.config[state]).forEach(this.rearrange.bind(this));
  }

  rearrange([region, blocks]) {
    blocks.forEach((selector) => {
      const block = this.element.querySelector(selector);
      if (block) {
        this[region].append(block);
      }
    });
  }

  listen() {
    // Listen for breakpoint changes
    Breakpoints.on('mobile tablet', 'enter', this.update.bind(this));
    Breakpoints.on('desktop', 'enter', this.update.bind(this));
  }

  ready() {
    this.element.classList.add('ready');
  }

  get header() {
    return this.element.querySelector('.header .layout');
  }

  get flyout() {
    return this.element.querySelector('.flyout .layout');
  }
}
